// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__3PIt8","isActivePlayer":"Question_isActivePlayer__28j54"};